import { render, staticRenderFns } from "./CountStatWidget.vue?vue&type=template&id=234a8255&"
import script from "./CountStatWidget.vue?vue&type=script&lang=js&"
export * from "./CountStatWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports